import BucksIcon from "../../../icons/BucksIcon.svelte";
const createPlaceholderList = (name) => [
    { key: `${name}_0`, name: `${name}_test_0` },
    { key: `${name}_1`, name: `${name}_test_1` },
    { key: `${name}_2`, name: `${name}_test_2` }
];
const marketplaceImageList = [
    { groupKey: 'US', groupList: new Array(3).fill(1).map((_, index) => ({ src: null, key: `img-select-${index}-us` })) },
    { groupKey: 'Paid search', groupList: new Array(3).fill(1).map((_, index) => ({ src: null, key: `img-select-${index}-search` })) },
    {
        groupKey: 'International', groupList: new Array(10).fill(1).map((_, index) => ({ src: null, key: `img-select-${index}-international` }))
    },
    { groupKey: 'Social', groupList: new Array(3).fill(1).map((_, index) => ({ src: null, key: `img-select-${index}-social` })) }
];
export var FilterType;
(function (FilterType) {
    FilterType["Dropdown"] = "dropdown";
    FilterType["Input"] = "input";
    FilterType["Number"] = "number";
    FilterType["RangeData"] = "range-data";
    FilterType["RangeNumber"] = "range-number";
})(FilterType || (FilterType = {}));
;
export const filtersSettings = {
    Brand: {
        type: FilterType.Dropdown,
        group: [],
        search: 'Find brand',
        totalAmount: '300',
        placeholder: 'select...',
        list: createPlaceholderList("Brand")
    },
    'Seller status': {
        type: FilterType.Dropdown,
        group: [],
        search: 'Find status',
        totalAmount: '300',
        list: createPlaceholderList("Status")
    },
    Marketplace: {
        type: FilterType.Dropdown,
        group: [],
        search: 'Find marketplace',
        totalAmount: '300',
        list: marketplaceImageList.map(item => ({
            key: item.groupKey,
            name: item.groupKey
        })),
        imagesList: marketplaceImageList
    },
    'Reference number': { type: FilterType.Input, placeholder: 'e.g. 123456', icon: null, initialValue: '' },
    Seller: {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find seller',
        list: createPlaceholderList("Seller")
    },
    Website: { type: FilterType.Input, placeholder: 'e.g. 123456', icon: null, initialValue: '' },
    'Product Name/Message/Caption': {
        type: 'input',
        placeholder: 'e.g. Spiderman T-Shirt',
        icon: null,
        value: ''
    },
    Notes: { type: FilterType.Input, placeholder: 'e.g. 123456', icon: null, initialValue: '' },
    Description: { type: FilterType.Input, placeholder: 'e.g. 123456', icon: null, initialValue: '' },
    'Profile Name': {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find seller',
        list: createPlaceholderList("Seller")
    },
    'Page Name': {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find seller',
        list: createPlaceholderList("Seller")
    },
    'Price Range': { type: FilterType.RangeNumber, placeholder: '', icon: null, initialValue: [100, 100] },
    'Report Type': {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find seller',
        list: createPlaceholderList("Seller")
    },
    Trademark: {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find trademark',
        list: createPlaceholderList("Seller")
    },
    Copyright: {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find copyright',
        list: createPlaceholderList("Seller")
    },
    'Marked Violator by': {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find violator',
        list: createPlaceholderList("Seller")
    },
    'Marker Approved by': {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find approver',
        list: createPlaceholderList("Seller")
    },
    'Reported by': {
        type: FilterType.Dropdown,
        totalAmount: '300',
        group: [],
        search: 'Find reporter',
        list: createPlaceholderList("Seller")
    },
    Detected: { type: FilterType.RangeData, placeholder: '', icon: null, initialValue: '' },
    Reported: { type: FilterType.RangeData, placeholder: '', icon: null, initialValue: '' },
    Removed: { type: FilterType.RangeNumber, placeholder: '', icon: null, initialValue: [100, 100] }
};
